export default function authHeader() {
  let token = localStorage.getItem('authToken');
  if (token) {
    // for Node.js Express back-end
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}
